import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../../config';
import common from './../../common';
import { getFixtureStatus } from './../../helper';
import { gamerCardFetchData, postSubscribe, editorialCardFetchData, eosFetchData } from './../../actions/HomeActions';
import { playersFetchData, triggerMixFetchData, triggerLiveScoreFetchData } from './../../actions/FormationActions';
import { relaunchLeague, previousSeasonDeleteLeague } from './../../actions/LeagueActions';
import { setTotalScore, closeDynamicCard } from './../../actions/AppActions';
import { withRouter } from 'react-router-dom';
import Welcome from './cards/Welcome';
import League from './cards/League';
import Team from './cards/Team';
import Banner from './cards/Banner';
import Email from './cards/Email';
import Newsletter from './cards/Newsletter';
import MdStatus from './cards/MdStatus';
import Prizes from './cards/Prizes';
import Editorial from './cards/Editorial';
import DreamTeam from './cards/DreamTeam';
import BestManager from './cards/BestManager';
import GeneralPopUp from './../GeneralPopUp';
import apiError from './../../constants/api-error';
import MdStatusEot from './cards/MdStatusEot';
import PlayerCard from './../playerCard';
import EOT from './cards/EOT';
import LeagueNew from './cards/LeagueNew'
import TransAndSubs from './cards/TransAndSubs'
import DynamicCards from './cards/DynamicCards';


class Home extends Component {
    constructor(props) {
        super(props);
        let guid = common.getGUID();
        let objCompOrder = {};
        objCompOrder[config.enumCard.Dynamic_Cards] = {
            name: config.enumCard.Dynamic_Cards,
            component: DynamicCards,
            isRemove: false
        }
        objCompOrder[config.enumCard.Welcome_card] = {
            name: config.enumCard.Welcome_card,
            component: Welcome,
            isRemove: true
        };
        objCompOrder[config.enumCard.League_card] = {
            name: config.enumCard.League_card,
            component: League,
            isRemove: false
        };
        objCompOrder[config.enumCard.League_new_card] = {
            name: config.enumCard.League_new_card,
            component: LeagueNew,
            isRemove: false
        };
        objCompOrder[config.enumCard.Trans_And_Sub] = {
            name: config.enumCard.Trans_And_Sub,
            component: TransAndSubs,
            isRemove: false
        };
        objCompOrder[config.enumCard.Team_card] = {
            name: config.enumCard.Team_card,
            component: Team,
            isRemove: false
        };
        objCompOrder[config.enumCard.Banner] = {
            name: config.enumCard.Banner,
            component: Banner,
            isRemove: false,
            jDesktopOrder: 2
        };
        objCompOrder[config.enumCard.Email_card] = {
            name: config.enumCard.Email_card,
            component: Email,
            isRemove: true
        };
        objCompOrder[config.enumCard.Newsletter_card] = {
            name: config.enumCard.Newsletter_card,
            component: Newsletter,
            isRemove: /* (guid ? false : true) */ true
        };
        objCompOrder[config.enumCard.Prizes_card] = {
            name: config.enumCard.Prizes_card,
            component: Prizes,
            isRemove: false,
            jDesktopOrder: 1
        };
        objCompOrder[config.enumCard.MD_status_card] = {
            name: config.enumCard.MD_status_card,
            component: MdStatus,
            isRemove: false
        };

        objCompOrder[config.enumCard.MD_status_card_eot] = {
            name: config.enumCard.MD_status_card_eot,
            component: MdStatusEot,
            isRemove: false
        };

        objCompOrder[config.enumCard.Editorial_card] = {
            name: config.enumCard.Editorial_card,
            component: Editorial,
            isRemove: true
        };
        objCompOrder[config.enumCard.Dream_team_card] = {
            name: config.enumCard.Dream_team_card,
            component: DreamTeam,
            isRemove: false
        };
        objCompOrder[config.enumCard.Best_manager_card] = {
            name: config.enumCard.Best_manager_card,
            component: BestManager,
            isRemove: false
        };
        objCompOrder[config.enumCard.EOT_card] = {
            name: config.enumCard.EOT_card,
            component: EOT,
            isRemove: false
        };
        this.onRedirectTo = this.onRedirectTo.bind(this);
        this.fnPostSubscribeAPI = this.fnPostSubscribeAPI.bind(this);
        this.fnRelaunchAPI = this.fnRelaunchAPI.bind(this);
        this.onDeletePreviousLeagueClick = this.onDeletePreviousLeagueClick.bind(this);
        this.updateWelcomeCardSeenStatus = this.updateWelcomeCardSeenStatus.bind(this);
        this.updateCardDismissedStatus = this.updateCardDismissedStatus.bind(
            this
        );
        let cardStatus = common.getLocalStorage('isCardDismissed');
        if (!cardStatus) {
            cardStatus = {};
        }
        let isCardClosed = cardStatus[guid];
        this.resetToast = this.resetToast.bind(this);
        let objCookie = common.getLocalStorage('objWelcomeCardDisplayed');
        if (!objCookie) {
            objCookie = {};
        }
        let isShownFirstTime = objCookie[guid];
        this.state = {
            objCompOrder: objCompOrder, isShownWelcomeFirstTime: isShownFirstTime,
            isCardClosed: isCardClosed,
            isErrorTostMessage: false, sErrorTostMessage: '',
            message: '',
            popupWrapperClass: '',
            iconClass: '',
            showPopup: false,
        };
    }

    timeout_mix = 0;
    timeout_local = 0;
    timeout_live = 0;

    componentDidMount() {
        this.initialize();
        if (Boolean(sessionStorage.getItem('createTeamSuccess')) === true) {
            sessionStorage.removeItem('createTeamSuccess');
            this.setState({
                message: this.props.trans['TEAM_CREATED_SUCCESSFULLY'],
                popupWrapperClass: 'si-warning-toast si-success-popup',
                iconClass: 'icon-ucl-tick',
                isToast: true,
                showPopup: true,
            });
        }
    }

    updateWelcomeCardSeenStatus(isShownFirstTime) {
        this.setState({ isShownWelcomeFirstTime: isShownFirstTime });
    }

    updateCardDismissedStatus(isCloseClicked) {
        this.setState({ isCardClosed: isCloseClicked });
    }

    fnPostSubscribeAPI(isSubscribe) {
        let self = this;
        const subscribePromise = self.props.postSubscribe(isSubscribe);
        subscribePromise.then((objSubscribe) => {
            let retVal = objSubscribe && objSubscribe.payload && objSubscribe.payload.Meta && objSubscribe.payload.Meta.RetVal;
            if (retVal === 1) {
                self.initialize();
            }
            else {
                //show toast message
            }
        }).catch(reason => {
        });
    }

    fnRelaunchAPI(GUID, leagueName, leagueCode, leagueID) {
        let self = this;
        self.onReActiveClick(leagueID, leagueCode);
    }

    onReActiveClick = (LeagueId, leagueCode) => {
        const GUID = common.getGUID();
        this.props.relaunchLeague(GUID, LeagueId, leagueCode).then((objRelaunch) => {
            const response = this.props.relaunchLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.reActivate[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (([1, 2].indexOf(retVal) >= -1)) {
                this.initialize();
                this.setState({
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            } else {
                let stateToSet = {
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                };
                this.setState(stateToSet);
            }
        });
    };
    onDeletePreviousLeagueClick = (LeagueId, leagueCode) => {
        const GUID = common.getGUID();
        this.props.previousSeasonDeleteLeague(GUID, LeagueId, leagueCode).then((objRelaunch) => {
            const response = this.props.previousSeasonDeleteLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.deletePreviousLeague[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (retVal === 1) {
                this.initialize();
                this.setState({
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-success-popup',
                    iconClass: 'icon-ucl-tick',
                    showPopup: true
                });
            } else {
                let stateToSet = {
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                };
                this.setState(stateToSet);
            }
        });
    };
    startInterval = (Deadline, OffSet, MixApiFixtureStatus) => {
        if (MixApiFixtureStatus !== config.fixtureStatus.isLock) {
            common.getDiffWithCurrentTimeInMinutes(Deadline, OffSet, (diffInMins) => {
                if (diffInMins > config.TIME_DIFF_TO_CONSIDER) {
                    if (diffInMins < config.MIXED_API_INTERVAL_START_TIME) {
                        this.timeout_mix = setTimeout(this.hitMixAPi, 1000 * config.MIXED_API_INTERVAL_DURATION);
                    } else {
                        this.timeout_local = setTimeout(() => {
                            this.startInterval(Deadline, OffSet, MixApiFixtureStatus);
                        }, 1000 * config.MIXED_API_BEFORE_INTERVAL_DURATION);
                    }
                }
            });
        }
    };
    hitMixAPi = () => {
        let self = this;
        this.props.triggerMixFetchData().then(() => {
            const mixedResponse = this.props.mixResponse;
            let { Deadline, Fixture } = mixedResponse;
            const { OffSet } = this.props.constraints;
            const MixApiFixtureStatus = getFixtureStatus(Fixture || {});
            if (Fixture !== null) {
                let data = self.props.homeData.Data.Value;
                const { gcStats } = data;
                const gamedayId = gcStats['GameDay'];
                if (+gamedayId === +Fixture['GDID']) {
                    const userFixtureStatus = getFixtureStatus(gcStats);
                    if (userFixtureStatus !== MixApiFixtureStatus) {
                        common.updateBusters('/bust-after-status-change');
                        return self.initialize();
                    }
                }
            }
            this.startInterval(Deadline, OffSet, MixApiFixtureStatus);
        });
    };
    callLiveAPI = () => {
        this.props.triggerLiveScoreFetchData().then(() => {
            this.timeout_live = setTimeout(() => {
                this.hitMixAPi();
                this.callLiveAPI();
            }, 1000 * config.MIXED_API_INTERVAL_DURATION);
        });
    };

    initialize() {
        this.clearAllTimeout();
        const fetchGamerCard = this.props.fetchGamerCard();
        const fetchEos = this.props.fetchEos();
        fetchGamerCard.then(() => {
            let data = this.props.homeData ? this.props.homeData.Data.Value : null;
            const { gcStats } = data;
            this.props.setTotalScore(gcStats['TrPoints']);
            const userFixtureStatus = getFixtureStatus(gcStats);
            if (userFixtureStatus === config.fixtureStatus.isLock) {
                this.callLiveAPI();
            } else if (userFixtureStatus !== config.fixtureStatus.isFinished) {
                this.hitMixAPi();
            }

            // eos call to be made of trcode post
            if (common.isEndOfSeason(gcStats.TrCode)) {
                fetchEos.then(() => {

                }).catch(reason => {
                })
            }

        }).catch(reason => {
        });
    }

    clearAllTimeout = () => {
        clearTimeout(this.timeout_mix);
        clearTimeout(this.timeout_local);
        clearTimeout(this.timeout_live);
    };

    componentWillUnmount() {
        this.clearAllTimeout();
    }

    onRedirectTo(sPath) {
        return this.props.history.push(sPath);
    }

    handleToast = (popupState) => {
        this.setState(popupState);
    };
    resetToast = () => {
        this.handleToast({ showPopup: false, message: '' });
    };

    render() {
        let self = this;
        let data = self.props.homeData ? self.props.homeData.Data.Value : null;
        let eosData = self.props.homeData ? self.props.homeData.Data.Value : null;
        let OffSet = '+2';
        let enumScinarioCode = null;
        let enumUserScinarioCode = null;
        let arrOrderHomeCard = [];
        let serverDate = self.props.homeData && self.props.homeData.Data ? self.props.homeData.Data.FeedTime.UTCtime : window.serverDate;
        let deadLine = '';
        let isAccounting = "";
        let gamedayId = self.props.constraints ? self.props.constraints.GamedayId : 0;
        let IsNewsletter = 0;
        let isShownWelcomeFirstTime = self.state.isShownWelcomeFirstTime;
        let isCardClosed = self.state.isCardClosed;
        let arrLeague = [];
        let arrRightSide = [];
        let gcStats = null;
        let fetchEditorialCard = self.props.fetchEditorialCard;
        let fnRelaunchAPI = self.fnRelaunchAPI;
        let onDeletePreviousLeagueClick = self.onDeletePreviousLeagueClick;
        let editorialData = self.props.editorialData;
        let arrPlayers = [];
        let showDC = false;
        let completedGD = "";
        if (data) {
            isAccounting = self.props.homeData.Data.Value.IsAccounting;
            gcStats = data.gcStats;
            arrPlayers = data['gcPlayers'];
            if (data.OffSet) {
                OffSet = data.OffSet;
            }

            if (gcStats["GdPointsCal"]) {
                completedGD = gcStats["GdPointsCal"];
            }

            if (gcStats) {
                deadLine = data.gcStats['DeadLineDate'];
                // isAccounting = data.gcStats["isAccounting"];
                enumScinarioCode = data.gcStats['TrCode'];
                enumUserScinarioCode = data.gcStats['UtCode'];
                arrOrderHomeCard = config.objOrderHomeCard[enumScinarioCode];
                gamedayId = data.gcStats['GameDay'];
                IsNewsletter = data.gcStats.IsNewsletter;
                showDC = +(
                    data.gcStats['IsDreamTeamShow'] === 1 ||
                    data.ShowOverallDreamTeam === 1
                );
                arrLeague = [];
                let arrLastSeasonLeague = data['gcLastSeasonLeague'];
                if (arrLastSeasonLeague) {
                    for (let j = 0; j < (arrLastSeasonLeague || []).length; j++) {
                        let rowPrev = arrLastSeasonLeague[j];
                        rowPrev.isLastSeason = true;
                        arrLeague.push(rowPrev);
                    }
                }
                let arrLeagueCurrent = data['gcLeague'];
                if (arrLeagueCurrent) {
                    for (let j = 0; j < (arrLeagueCurrent || []).length; j++) {
                        let rowNew = arrLeagueCurrent[j];
                        rowNew.isLastSeason = false;
                        arrLeague.push(rowNew);
                    }
                }
            }
        }
        let objCompOrder = self.state.objCompOrder;
        let arrOrderHomeCardComp = arrOrderHomeCard && arrOrderHomeCard.map((element, index) => {
            let objCompOrderT = objCompOrder[element];
            let DynComp = objCompOrderT && !objCompOrderT.isRemove ? objCompOrderT.component : null;
            let sMobClass = objCompOrderT && !objCompOrderT.jDesktopOrder ? '' : 'si-mob';
            let objProps = {
                key: index,
                trans: self.props.trans,
                gcStats: gcStats,
                data: data,
                enumScinarioCode: enumScinarioCode,
                enumUserScinarioCode: enumUserScinarioCode,
                players: self.props.players,
                serverDate: serverDate || window.serverDate,
                liveScore: this.props.liveScore,
                deadLine: deadLine,
                gamedayId: gamedayId,
                OffSet,
                showDC,
                onRedirectTo: self.onRedirectTo,
                initialize: self.initialize,
                IsNewsletter: IsNewsletter,
                fnPostSubscribeAPI: self.fnPostSubscribeAPI,
                isShownWelcomeFirstTime: isShownWelcomeFirstTime,
                updateWelcomeCardSeenStatus: self.updateWelcomeCardSeenStatus,
                isCardClosed: isCardClosed,
                updateCardDismissedStatus: self.updateCardDismissedStatus,
                arrLeague: arrLeague,
                fetchEditorialCard: fetchEditorialCard,
                editorialData: editorialData,
                arrPlayers: arrPlayers,
                fnRelaunchAPI: fnRelaunchAPI,
                onDeletePreviousLeagueClick: onDeletePreviousLeagueClick,
                finalMatchPoints: self.props.finalMatchPoints,
                eosStats: self.props.eosStats,
                constraints: self.props.constraints,
                fixtures: self.props.fixtures,
                isAccounting: isAccounting,
                dynamicCards: self.props.dynamicCards,
                closeDynamicCard: self.props.closeDynamicCard,
                GdPointsCal: completedGD
            };
            return (DynComp && <DynComp { ...objProps } />);
        });
        for (let sKey in objCompOrder) {
            let objRow = objCompOrder[sKey];
            if (objRow.jDesktopOrder) {
                arrRightSide.push(objRow);
            }
        }
        let arrOrderRightCardComp = arrRightSide && arrRightSide.sort((a, b) => {
            let valueA = a.jDesktopOrder;
            let valueB = b.jDesktopOrder;
            if (valueA > valueB) {
                return 1;
            }
            if (valueA < valueB) {
                return -1;
            }
            return 0;
        }).map((element, index) => {
            let objCompOrderT = element;
            let jDesktopOrder = element.jDesktopOrder;
            let DynComp = objCompOrderT && !objCompOrderT.isRemove ? objCompOrderT.component : null;
            let objProps = {
                key: index,
                trans: self.props.trans,
                liveScore: this.props.liveScore,
                gcStats: gcStats,
                OffSet,
                enumScinarioCode: enumScinarioCode,
                enumUserScinarioCode: enumUserScinarioCode,
                jDesktopOrder: jDesktopOrder,
            };
            return (DynComp && <DynComp { ...objProps } />);
        });
        const { message, showPopup, popupWrapperClass, iconClass, isToast } = this.state;
        const popupProps = {
            showPopup,
            isToast,
            resetToast: self.resetToast,
            message,
            wrapperClass: popupWrapperClass,
            iconClass: iconClass
        };
        return <div className="si-main-component si-homepage si-no-anim">
            <div className="si-container">
                <div className="header-block" />
                <div className="my-col-wrapper">
                    <div className="my-col-1">
                        { arrOrderHomeCardComp && arrOrderHomeCardComp }
                    </div>
                    <div className="my-col-2 si-web">
                        { arrOrderRightCardComp && arrOrderRightCardComp }
                    </div>
                </div>
                {/* <div className="si-no-landscape" /> */ }
            </div>
            { this.props.isPlayerCardVisible && this.props.overview ? <PlayerCard GDIDFromFetch={ gcStats.GameDay } /> : null }
            <GeneralPopUp { ...popupProps } />
        </div>
    }
}

const mapSateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
        mixResponse: state.formationData.mixResponse,
        liveScore: state.formationData.liveScore.response,
        homeData: state.homeData.gamerCardData,
        players: state.homeData.players,
        objSubscribe: state.homeData.objSubscribe,
        editorialData: state.homeData.editorialData,
        relaunchLeagueResponse: state.leaguesData.relaunchLeagueResponse,
        previousSeasonDeleteLeagueResponse: state.leaguesData.previousSeasonDeleteLeagueResponse,
        finalMatchPoints: state.homeData.finalPoints,
        eosStats: state.homeData.eosStats,
        fixtures: state.formationData.fixtures,
        isPlayerCardVisible: state.formationData.isPlayerCardVisible,
        overview: state.formationData.overview,
        playerCardDetails: state.formationData.playerCardDetails,
        dynamicCards: state.appData.dynamicCards,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        fetchGamerCard: () => dispatch(gamerCardFetchData()),
        fetchEos: () => dispatch(eosFetchData()),
        triggerMixFetchData: () => dispatch(triggerMixFetchData()),
        triggerLiveScoreFetchData: () => dispatch(triggerLiveScoreFetchData()),
        fetchPlayers: (gamedayId) => dispatch(playersFetchData(gamedayId)),
        postSubscribe: (isSubscribe) => dispatch(postSubscribe(isSubscribe)),
        fetchEditorialCard: () => dispatch(editorialCardFetchData()),
        relaunchLeague: (GUID, leagueName, leagueCode, leagueID) => dispatch(relaunchLeague(GUID, leagueName, leagueCode, leagueID)),
        previousSeasonDeleteLeague: (GUID, LeagueId, leagueCode) => dispatch(previousSeasonDeleteLeague(GUID, LeagueId, leagueCode)),
        setTotalScore: (score) => dispatch(setTotalScore(score)),
        closeDynamicCard: (dynamicCard) => dispatch(closeDynamicCard(dynamicCard)),
    };
};
export default withRouter(connect(mapSateToProps, mapDispatchToProps)(Home));


// WEBPACK FOOTER //
// ./src/components/home/index.js